// Api
import AxiosClient from '@api/axiosClient';
// Urls
import { urls } from './urls';
// Models
import { IYearPeriodId } from '@models/PayrollAdjuster';
import { IFormikContributorValues } from '@pages/company/components/models/FormikConfig';
import { ApiResponse } from '@models/ApiResponse';
import {
    ITaxPayer,
    IHandleSearchTaxpayerParams,
    ITaxpayerResponse,
    ISpreedsheetPaidInformation,
    ITaxPayerBasicInformation,
} from '@models/TaxPayer';
import { IPILACredentials } from '@models/Pila';

export const apiPostGetStateTemplate = (data: IYearPeriodId): Promise<unknown> =>
    AxiosClient.post(urls.pila.getState, data, false);

export const apiPostSummaryTemplatePila = (data: IYearPeriodId): Promise<unknown> =>
    AxiosClient.post(urls.pila.summary, data, false);

export const apiPostTaxpayerPrechargedInformation = (data: IPILACredentials): Promise<ApiResponse<ITaxPayerBasicInformation>> =>
    AxiosClient.post(urls.pila.getTaxpayerPrechargedInformation, data, false);

export const apiGetTaxPayer = (): Promise<ITaxPayer> => AxiosClient.get(urls.pila.getTaxpayer);

export const apiPostTaxPayerByDocument = (data: IHandleSearchTaxpayerParams): Promise<ApiResponse<ITaxpayerResponse>> =>
    AxiosClient.post(urls.pila.getTaxpayerByDocument, data, false);

export const apiPostPaymentSocialSecurityPila = (data: IYearPeriodId): Promise<ApiResponse<ISpreedsheetPaidInformation>> =>
    AxiosClient.post(urls.pila.postPaymentSocialSecurityPila, data, false);

export const apiPostCreatePilaUser = (data: IFormikContributorValues): Promise<ApiResponse<string>> =>
    AxiosClient.post(urls.pila.createUser, data, false);
